var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497,60h-76.518C413.513,25.809,383.216,0,347,0s-66.513,25.809-73.482,60H15C6.709,60,0,66.709,0,75s6.709,15,15,15 h258.518c6.969,34.191,37.266,60,73.482,60s66.513-25.809,73.482-60H497c8.291,0,15-6.709,15-15S505.291,60,497,60z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497,241H239.482c-6.969-34.191-37.266-60-73.482-60s-66.513,25.809-73.482,60H15c-8.291,0-15,6.709-15,15s6.709,15,15,15 h77.518c6.969,34.191,37.266,60,73.482,60s66.513-25.809,73.482-60H497c8.291,0,15-6.709,15-15C512,247.709,505.291,241,497,241z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497,422h-76.518c-6.969-34.191-37.266-60-73.482-60s-66.513,25.809-73.482,60H15c-8.291,0-15,6.709-15,15 c0,8.291,6.709,15,15,15h258.518c6.969,34.191,37.266,60,73.482,60s66.513-25.809,73.482-60H497c8.291,0,15-6.709,15-15 C512,428.709,505.291,422,497,422z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.050fa185808b41541baead728c3170b8.svg";
export { ForwardRef as ReactComponent };